import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_RFIS} from "../actions/rfis";

/*
Structure of rfis model:

{
  data: {
    [uuid]: {
      permissions: {
        // these are returned by the backend; may not be up to date
        view: bool
        update: bool
        delete: bool
      }
      resource: {
        // these are returned by the backend; may not be up to date
        id: string // uuid
        projectid: string // uuid
        createdbyuserid: string // uuid
        owneruserid: string // uuid
        createdbycompanyid: string // uuid
        ownercompanyid: string // uuid
        datecreated: datetime
        reply: string
        replydate: date
        number: string
        title: string
        description: string
        belongsto: string // uuid
        status: string // code-drive code_projectrfistatus
        duedate: date
        csicodes: array of string // code-driven code_csi
        active: bool
      }
    }
  }
  indexes: {
    // used for indexing entries by different fields other than the id field
    projectid: {
      [projectid]:
        [rfiid]: dontcare
    }
  }

}
 */

const rfisInitial = {
  data: {},
  indexes: {
    projectid: {}
  },
};

const rfisReducer = createReducer(rfisInitial,
  {
    [ADD_RFIS]: (state, action) => {
      let newState = state;
      action.payload.forEach(item => {
        newState = R.over(R.lensPath(['data', item.resource.id]), () => item)(newState);
        newState = R.over(R.lensPath(['indexes', 'projectid', item.resource.projectid]), value => {
          if (!value) {
            return {[item.resource.id]: 1};
          } else {
            return {...value, [item.resource.id]: 1};
          }
        })(newState);
      });
      return newState;
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default rfisReducer;



// WEBPACK FOOTER //
// ./src/reducers/rfis.js